/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    Configuration,
    ConfigurationParameters,
    QuickMenuApi,
    QuickMenuShortcutsGetV3Request,
    QuickMenuShortcutV3,
    UiDestinationTypeV3,
} from 'client-code/homeshortcut';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { IQuickMenuShortcutServiceRepository } from '../interfaces/IQuickMenuShortcutServiceRepository';
import { Log } from '../logging';
import { QuickMenuShortcutServiceV3Contract } from '../servicecontracts';
import { TServicesParams } from '../types';
import { UniqueIdentifier } from '../utils';

export class QuickMenuShortcutServiceRepositoryImplV3
    implements IQuickMenuShortcutServiceRepository<QuickMenuShortcutServiceV3Contract>
{
    private static TAG: string = 'QuickMenuShortcutServiceRepositoryImplV3';

    private mServiceParams: TServicesParams;

    public constructor(params: TServicesParams) {
        this.mServiceParams = params;
    }

    /**
     * @inheritdoc
     */
    public async fetchQuickMenuShortcuts(): Promise<QuickMenuShortcutV3[]> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.GUIDE).headers;
            const configurationParameters: ConfigurationParameters = {
                basePath: this.mServiceParams.basePath,
                apiKey: this.mServiceParams.accessToken,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };
            const configuration = new Configuration(configurationParameters);
            const quickMenuApi = new QuickMenuApi(configuration);
            const requestParams: QuickMenuShortcutsGetV3Request = {
                applicationName: commonHeaders.ApplicationName,
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationVersion: commonHeaders.ApplicationVersion,
                deviceType: commonHeaders.DeviceType,
                productName: commonHeaders.ProductName,
                bodyId: this.mServiceParams.bodyId,
                acceptLanguage: commonHeaders['Accept-Language'],
                xAmznRequestId: UniqueIdentifier.generateXAmznRequestId(),
                whiny: this.mServiceParams.whiny || 'false',
            };

            const quickMenuResponse = await quickMenuApi.quickMenuShortcutsGetV3(requestParams);
            return quickMenuResponse.data;
        } catch (error) {
            Log.e(QuickMenuShortcutServiceRepositoryImplV3.TAG, 'fetchQuickMenuShortcuts', error);
            throw error;
        }
    }
}
